export default (cardNumber) => {
  return cardNumber.toString().replace(/\s+|-/g, '');
};
